import { render } from "./LottieAnimation.vue?vue&type=template&id=1358b534"
import script from "./LottieAnimation.vue?vue&type=script&lang=js"
export * from "./LottieAnimation.vue?vue&type=script&lang=js"

import "./LottieAnimation.vue?vue&type=style&index=0&id=1358b534&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__